const $ = jQuery.noConflict();
import GoogleMapsEmbed from './googleMapsEmbed';

'use strict';
const SearchRepLocations = {
	$repElements: [],
	$initialRepElements: [],
	$clearSearch: $('.js-clear-search'),
	latitude: '',
	longitude: '',
	service: '',
	state: '',
	stateShort: '',
	address: '',
	isStateSearch: false,
	/**
	 * @description init search
	 */
	init: function() {
		const _this = this;
		$(document).ready(function() {
			const searchInput = $('.js-rep-search');
			if (searchInput.length > 0) {
				_this.$repElements = $('.js-single-tile');
				_this.$initialRepElements = $('.js-single-tile').clone();
				_this.initGoogleAutocomplete();
				_this.attachRepEvents();
				$('.js-search-form').on('submit', function(e) {
					e.preventDefault();
				});

				_this.$clearSearch.on('click', function() {
					_this.clearSearch();
				});

				if (_this.$repElements.length > 0) {
					GoogleMapsEmbed.init(_this.$repElements);
				}
			}
		});
	},

	/** @description Initialize autocomplete functionality */
	initGoogleAutocomplete: function() {
		const _this = this;
		let autocomplete;

		const initAutocomplete = () => {
			if (typeof google !== 'undefined') {
				const addressField = document.querySelector('.js-rep-search');
				const options = {
					types: ['geocode'],
					componentRestrictions: {country: 'us'},
				};
				autocomplete = new google.maps.places.Autocomplete(addressField, options);// eslint-disable-line
				autocomplete.addListener('place_changed', fillInAddress);
			}
		};

		const locationChangeEvent = () => {
			const repSearch = $('.js-rep-search');
			repSearch.on('change', function() {
				SearchRepLocations.latitude = '';
				SearchRepLocations.longitude = '';
				SearchRepLocations.isStateSearch = false;
				SearchRepLocations.stateShort = '';
				const currentVal = $(this).val().replace(/<\/?[^>]+(>|$)/g, '').trim();
				SearchRepLocations.address = currentVal;
				if (currentVal === '') {
					_this.resetRepState();
				}
			});

			repSearch.on('keyup', function() {
				if ($(this).val() !== '') {
					_this.$clearSearch.addClass('is-active');
				} else {
					_this.$clearSearch.removeClass('is-active');
				}
			});
		};

		const fillInAddress = () => {
			_this.applyPlace(autocomplete.getPlace());
		};

		initAutocomplete();
		locationChangeEvent();
		this.initRegionSuggestions();
		window.initAutocomplete = initAutocomplete;
	},

	/**
	 * Applies a selected/geocoded place to the search state and filters the reps
	 */
	applyPlace: function(place) {
		if (!place || !place.geometry || !place.address_components) return;

		SearchRepLocations.latitude = place.geometry.location.lat();
		SearchRepLocations.longitude = place.geometry.location.lng();

		// Detect if the user searched for a state (not a city/zip)
		const placeTypes = place.types || [];
		SearchRepLocations.isStateSearch = placeTypes.includes('administrative_area_level_1');

		let state = '';
		let stateShort = '';
		place.address_components.forEach((component) => {
			if (component.types.includes('administrative_area_level_1')) {
				state = component.long_name;
				stateShort = component.short_name.toLowerCase();
			}
		});
		SearchRepLocations.state = state;
		SearchRepLocations.stateShort = stateShort;

		this.calculateDifferences();
		this.removeActiveTile();
		$('.js-dealers').animate({scrollTop: 0}, 500);
	},

	/**
	 * Adds "Northern California" and "Southern California" suggestions to the
	 * Google autocomplete dropdown when the user types "California". Google's
	 * prefix matching never surfaces these regions on its own, and the stock
	 * widget can't be extended, so the items are injected into its
	 * .pac-container element directly.
	 */
	initRegionSuggestions: function() {
		const _this = this;
		const regions = ['Northern California', 'Southern California'];

		const shouldSuggest = () => {
			const query = ($('.js-rep-search').val() || '').toLowerCase().trim();
			return query.length >= 4 && ('california'.startsWith(query) || query.startsWith('california'));
		};

		const injectItems = (container) => {
			const hasCustomItems = container.querySelector('.js-region-pac-item') !== null;
			if (!shouldSuggest()) {
				if (hasCustomItems) {
					container.querySelectorAll('.js-region-pac-item').forEach((el) => el.remove());
				}
				return;
			}
			if (hasCustomItems) return;

			regions.slice().reverse().forEach((region) => {
				const item = document.createElement('div');
				item.className = 'pac-item js-region-pac-item';
				item.dataset.region = region;
				item.innerHTML = '<span class="pac-icon pac-icon-marker"></span>' +
					'<span class="pac-item-query"><span class="pac-matched">' + region + '</span></span>' +
					'<span>CA, USA</span>';
				container.insertBefore(item, container.firstChild);
			});
		};

		// The .pac-container is created lazily on the first keystroke; watch for it,
		// then re-inject whenever Google rewrites the suggestion list
		const bodyObserver = new MutationObserver(() => {
			const container = document.querySelector('.pac-container');
			if (!container) return;
			bodyObserver.disconnect();
			injectItems(container);
			const containerObserver = new MutationObserver(() => injectItems(container));
			containerObserver.observe(container, {childList: true});
		});
		bodyObserver.observe(document.body, {childList: true});

		// mousedown (not click) so the input never blurs, matching the widget's own items
		$(document).on('mousedown', '.js-region-pac-item', function(e) {
			e.preventDefault();
			e.stopPropagation();
			_this.selectRegion($(this).data('region'));
		});
	},

	/**
	 * Handles selection of an injected region suggestion
	 */
	selectRegion: function(region) {
		const _this = this;
		const address = region + ', CA, USA';

		$('.js-rep-search').val(address);
		this.$clearSearch.addClass('is-active');
		$('.pac-container').hide();

		const geocoder = new google.maps.Geocoder();// eslint-disable-line
		geocoder.geocode({address: address}, function(results, status) {
			if (status !== 'OK' || !results || !results.length) return;
			SearchRepLocations.address = address;
			_this.applyPlace(results[0]);
		});
	},

	/**
	 * Removes active tile and sets map to default center location
	 */
	removeActiveTile: function() {
		$('.js-single-tile.is-active').removeClass('is-active');
	},

	/**
	 * Calculates the distance between rep locations
	 */
	calculateDifferences: function() {
		const _this = this;
		const markersToHide = [];
		let shownDealers = 0;

		const searchedState = SearchRepLocations.state.toLowerCase().trim();

		this.$repElements.each(function(index, element) {
			const $el = $(element);
			const latRaw = $el.data('lat');
			const lngRaw = $el.data('lng');
			const markerId = String($el.data('id'));
			const supportedStates = ($el.data('states') || '').toString().toLowerCase();
			const addressState = ($el.data('address-state') || '').toString().toLowerCase();
			// Collect IDs for all extra showroom markers so they can be hidden/shown together with the tile
			const extraLocations = $el.data('extra-locations') || [];
			const extraMarkerIds = extraLocations.map(loc => String(loc.id));

			const matchesState = (state, stateShort) => {
				return supportedStates.includes(state) || (addressState !== '' && addressState === stateShort);
			};

			if (!latRaw || !lngRaw) {
				if (searchedState !== '') {
					if (matchesState(searchedState, SearchRepLocations.stateShort)) {
						$el.removeClass('hidden-element');
						$el.data('distance', 0.1);
						shownDealers++;
					} else {
						$el.addClass('hidden-element');
						markersToHide.push(markerId);
						extraMarkerIds.forEach(id => markersToHide.push(id));
						$el.data('distance', 999999);
					}
				} else {
					$el.addClass('hidden-element');
					markersToHide.push(markerId);
					extraMarkerIds.forEach(id => markersToHide.push(id));
					$el.data('distance', 999999);
				}
				return;
			}

			// When the user searched for a state, use state matching instead of distance
			if (SearchRepLocations.isStateSearch && searchedState !== '') {
				if (matchesState(searchedState, SearchRepLocations.stateShort)) {
					$el.removeClass('hidden-element');
					$el.data('distance', 0.1);
					shownDealers++;
				} else {
					$el.addClass('hidden-element');
					markersToHide.push(markerId);
					extraMarkerIds.forEach(id => markersToHide.push(id));
					$el.data('distance', 999999);
				}
				return;
			}

			const lat = parseFloat(latRaw);
			const lng = parseFloat(lngRaw);

			const distance = _this.getDistanceInMiles(
				SearchRepLocations.latitude,
				SearchRepLocations.longitude,
				lat,
				lng
			);

			$el.data('distance', distance);

			const distanceSpan = $el.find('.js-distance-span');
			if (distanceSpan.length) {
				distanceSpan.html(`<span class="dealer-tile__distance">${distance} mi away</span>`);
			}

			if (parseFloat(distance) > 60) {
				// If we have state info (e.g. "Southern California, CA, USA"), fall back to state matching
				if (SearchRepLocations.stateShort !== '' && searchedState !== '' && matchesState(searchedState, SearchRepLocations.stateShort)) {
					$el.removeClass('hidden-element');
					shownDealers++;
				} else {
					markersToHide.push(markerId);
					extraMarkerIds.forEach(id => markersToHide.push(id));
					$el.addClass('hidden-element');
				}
			} else {
				$el.removeClass('hidden-element');
				shownDealers++;
			}
		});

		const sortedElements = this.$repElements.sort((a, b) => {
			const aIsNotRep = $(a).data('card-type') === 'not_a_rep' ? 1 : 0;
			const bIsNotRep = $(b).data('card-type') === 'not_a_rep' ? 1 : 0;
			if (aIsNotRep !== bIsNotRep) return aIsNotRep - bIsNotRep;
			return parseFloat($(a).data('distance')) - parseFloat($(b).data('distance'));
		});

		GoogleMapsEmbed.hideMarkers(markersToHide);
		$('.js-reps-container').html(sortedElements);
		$('.js-dealers-counter').text('(' + shownDealers + ' Results)');
		_this.attachRepEvents();
	},

	getDistanceInMiles: function(lat1, lon1, lat2, lon2) {
		const R = 3958.8;
		const dLat = (lat2 - lat1) * (Math.PI / 180);
		const dLon = (lon2 - lon1) * (Math.PI / 180);
		const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return (R * c).toFixed(2);
	},

	/**
	 * Attaches click event to rep cards
	 */
	attachRepEvents: function() {
		$('.js-single-tile').off('click').on('click', function(e) {
			// "View on Map" links handle their own marker navigation via googleMapsEmbed
			if ($(e.target).closest('.js-view-link').length) return;

			if (!$(this).hasClass('is-active')) {
				$('.js-single-tile.is-active').removeClass('is-active');
				$(this).addClass('is-active');
				GoogleMapsEmbed.updateCurrentMarker(String($(this).data('id')));
			}
		});
	},

	/**
	 * Resets rep elements to original state
	 */
	resetRepState: function() {
		$('.js-reps-container').html(this.$initialRepElements.clone());
		this.$repElements = $('.js-single-tile');
		this.$repElements.removeClass('hidden-element');
		this.$repElements.each(function() {
			$(this).data('distance', null);
			$(this).find('.js-distance-span').empty();
		});

		this.attachRepEvents();

		this.$clearSearch.removeClass('is-active');
		$('.js-dealers-counter').text('(' + this.$repElements.length + ' Results)');

		GoogleMapsEmbed.showAllMarkers();

		$('.js-dealers').animate({scrollTop: 0}, 500);
	},

	/**
	 * Clears search input and triggers change event
	 */
	clearSearch: function() {
		$('.js-rep-search').val('').change();
	},
};

export default SearchRepLocations;
